// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=Public+Sans:wght@500;600&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* @import '~antd/dist/antd.css'; */

html {
  direction: ltr;
}

html[dir='rtl'],
html[dir='rtl'] body {
  direction: rtl;
}

body {
  margin: 0;
  font-family: var(--font-sans);
  color: var(--header-text-color);
  background-color: var(--backgorud-default-color);
}

.error-toastr {
  background-color: var(--error-color-state);
  border-radius: var(--radius-md) !important;
}

.ant-notification-notice-with-icon .ant-notification-notice-message {
  color: white;
}

.success-toastr {
  background-color: var(--success-color-state);
  border-radius: var(--radius-md) !important;
}

.ant-notification-close-x .anticon svg {
  display: none;
}

:root {
  /* Clinical Precision System (Stitch) */
  --font-sans: 'Inter', system-ui, -apple-system, sans-serif;
  --font-label: 'Public Sans', 'Inter', system-ui, sans-serif;
  --radius-md: 8px;
  --radius-lg: 12px;
  --control-height: 36px;
  --sidebar-width: 256px;
  --sidebar-collapsed-width: 72px;
  --gutter-desktop: 24px;

  --input-text-color: #0F172A;
  --border-color: #CBD5E1;
  --border-muted: #E2E8F0;
  --success-color-state: #10B981;
  --error-color-state: #DC2626;
  --header-text-color: #0F172A;
  --success-color-state-for-inputs: #059669;
  --error-color-state-for-inputs: #B91C1C;
  --drower-close-color: #DC2626;
  --warning-color-state: #D97706;
  --primary-color: #0EA5E9;
  --primary-hover: #0284C7;
  --primary-active: #1E3A8A;
  --backgorud-default-color: #F1F5F9;
  --surface-subtle: #F8FAFC;
  --table-body-content-color: #475569;
  --description-text: #64748B;
  --tab-title-color: #64748B;
  --profile-job-tag-background-color-hex: 183, 51, 232;
  --profile-job-tag-color: #a80ced;
  --profile-availability-background-color-hex: 16, 185, 129;
  --profile-availability-color: #10B981;
  --primary-color-hex: 14, 165, 233;
  --menu-color: #0F172A;
  --icon-color: #64748B;
  --selected-menu-color: #E0F2FE;
  --selected-menu-text: #0284C7;
  --report-numbers: #1E3A8A;
  --rx-top-offset: 0px;
  --rx-right-offset: 0px;
  --rx-bottom-offset: 0px;
  --rx-left-offset: 0px;
  --focus-ring: rgba(14, 165, 233, 0.20);
}

.Header-24-bold {
  font-family: var(--font-sans);
  font-size: 24px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 30px;
  letter-spacing: -0.015em;
  color: var(--header-text-color);
}

.Header-20-bold {
  font-family: var(--font-sans);
  font-size: 20px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 26px;
  letter-spacing: -0.01em;
  color: var(--header-text-color);
}

.Header-18-M {
  font-family: var(--font-sans);
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 22px;
  letter-spacing: -0.005em;
}

.Header-16-M {
  font-family: var(--font-sans);
  font-size: 13px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 16px;
  letter-spacing: 0;
}

.Header-R-16 {
  font-family: var(--font-sans);
  font-size: 15px;
  font-weight: 400;
  font-stretch: normal;
  font-style: normal;
  line-height: 22px;
  letter-spacing: normal;
}

.Header-R-14 {
  font-family: var(--font-label);
  font-size: 13px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 16px;
  letter-spacing: normal;
}

.body---14pt-R {
  font-family: var(--font-sans);
  font-size: 14px;
  font-weight: 400;
  font-stretch: normal;
  font-style: normal;
  line-height: 20px;
  letter-spacing: normal;
}

.body-8pt {
  font-family: var(--font-label);
  font-size: 11px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 14px;
  letter-spacing: 0.04em;
}

.title {
  margin-bottom: 36px;
}

.hidden-divider {
  min-height: 36px;
}

.table-body-content {
  color: var(--table-body-content-color);
}

.description-text {
  color: var(--description-text);
}

.description-text-heavy {
  color: #525b66;
}

.report_number {
  color: var(--report-numbers);
}

.normal-button {
  width: 186px !important;
  height: var(--control-height) !important;
  min-height: var(--control-height) !important;
  padding: 0 20px !important;
  border-radius: var(--radius-md) !important;
  background-color: var(--primary-color);
  display: flex;
  align-items: center;
  justify-content: center;
  border-color: rgba(0, 0, 0, 0);
  color: white !important;
  box-shadow: none !important;
}
.drawer-close-button {
  width: 186px !important;
  height: var(--control-height) !important;
  min-height: var(--control-height) !important;
  padding: 0 20px !important;
  border-radius: var(--radius-md) !important;
  background-color: white !important;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--border-color) !important;
  color: var(--primary-active) !important;
}

.widder-normal-button {
  width: 220px !important;
  height: var(--control-height) !important;
  min-height: var(--control-height) !important;
  padding: 0 20px !important;
  border-radius: var(--radius-md) !important;
  background-color: var(--primary-color);
  display: flex;
  align-items: center;
  justify-content: center;
  border-color: rgba(0, 0, 0, 0);
  color: white !important;
  box-shadow: none !important;
}

.normal-button:hover,
.normal-button:focus {
  background-color: var(--primary-hover) !important;
}

.normal-button:active {
  background-color: var(--primary-active) !important;
}

.normal-secondary-button {
  width: 188px;
  height: var(--control-height);
  padding: 0 20px;
  border-radius: var(--radius-md);
  background-color: var(--surface-subtle);
  color: var(--primary-active);
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--border-color);
}

.normal-secondary-button:hover,
.normal-secondary-button:focus {
  background-color: var(--surface-subtle);
  color: var(--primary-active);
  border-color: #94A3B8;
}

.input-border,
.ant-select-selector {
  border-color: var(--border-color) !important;
  border-radius: var(--radius-md) !important;
  height: var(--control-height) !important;
}

.group-input-border,
.ant-select-selector {
  border-color: var(--border-color) !important;
  border-radius: 0px;
  border-start-start-radius: var(--radius-md) !important;
  border-end-start-radius: var(--radius-md);
  height: var(--control-height) !important;
}

.text-area-border {
  border-color: var(--border-color) !important;
  border-radius: var(--radius-md) !important;
}

.ant-input-wrapper.ant-input-group input {
  border-color: var(--border-color) !important;
  border-top-left-radius: var(--radius-md) !important;
  border-bottom-left-radius: var(--radius-md) !important;
}

.ant-input-wrapper.ant-input-group .ant-select {
  /* border-color: var(--border-color) !important; */
  border-top-right-radius: var(--radius-md) !important;
  border-bottom-right-radius: var(--radius-md) !important;
}

.ant-input:focus,
.ant-input-focused,
.ant-select-focused .ant-select-selector,
.ant-picker-focused {
  border-color: var(--primary-color) !important;
  box-shadow: 0 0 0 2px var(--focus-ring, rgba(14, 165, 233, 0.20)) !important;
}

.ant-form-item-has-error input,
.ant-form-item-has-error .ant-input-number,
.ant-form-item-has-error :not(.ant-input-affix-wrapper-disabled):not(.ant-input-affix-wrapper-borderless).ant-input-affix-wrapper,
.ant-form-item-has-error .ant-select:not(.ant-select-disabled):not(.ant-select-customize-input) .ant-select-selector,
.ant-form-item-has-error .ant-picker {
  border-color: var(--error-color-state-for-inputs) !important;
}

.ant-form-item-has-error #Vector-2,
.ant-form-item-has-error #Vector-3 {
  fill: var(--error-color-state-for-inputs) !important;
}

.ant-input-number {
  display: flex !important;
  align-items: center !important;
}

.ant-form-item-explain,
.ant-form-item-has-error.ant-form-item-has-feedback .ant-form-item-children-icon {
  color: var(--error-color-state-for-inputs) !important;
}

.ant-table-thead>tr>th {
  background: var(--surface-subtle);
  border-bottom: 1px solid var(--border-color);
  font-family: var(--font-label);
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--table-body-content-color);
}

.ant-table-tbody>tr>td {
  border-bottom: 1px solid var(--border-muted);
}

.ant-table-tbody>tr:hover>td {
  background: var(--backgorud-default-color) !important;
}

td {
  background-color: #fff;
}


.ant-layout.ant-layout-has-sider.ant-layout-rtl td:first-child,
.ant-layout.ant-layout-has-sider.ant-layout-rtl th:first-child {
  border-radius: 0px 10px 10px 0px !important;
  border-left: 1px solid var(--backgorud-default-color);
}

.ant-layout.ant-layout-has-sider.ant-layout-rtl td:last-child,
.ant-layout.ant-layout-has-sider.ant-layout-rtl th:last-child {
  border-radius: 10px 0px 0px 10px !important;
}

.ant-layout.ant-layout-has-sider td:first-child,
.ant-layout.ant-layout-has-sider th:first-child {
  border-radius: 10px 0px 0px 10px !important;
  border-right: 1px solid var(--backgorud-default-color);
}

.ant-layout.ant-layout-has-sider td:last-child,
.ant-layout.ant-layout-has-sider th:last-child {
  border-radius: 0px 10px 10px 0px !important;
}

.ant-table {
  background: rgba(0, 0, 0, 0);
}

.ant-table table {
  /* border-spacing: 0px 10px; */
}

.ant-table-thead>tr>th,
.ant-table-tbody>tr>td,
.ant-table tfoot>tr>th,
.ant-table tfoot>tr>td {
  padding: 8px 16px;
}

.action-button {
  display: flex !important;
  align-items: flex-end;
  justify-content: flex-end;
  font-size: 20px;
}

.page-header {
  background-color: #ffffff;
  border-bottom: 1px solid #E2E8F0;
  padding: 20px 24px 16px;
  margin: 0;
  position: sticky;
  top: 0;
  z-index: 3;
}

.site-content-collapsed-layout .page-header,
.ant-layout-rtl .page-header,
.ant-layout-rtl .site-content-collapsed-layout .page-header {
  left: auto !important;
  right: auto !important;
}

.ant-layout {
  background-color: transparent;
}

.page-content,
.index-page-content,
.new-pages-content,
.new-pages-content-with-header {
  margin: 24px;
}

.page-subcontent,
.new-pages-sub-content {
  margin: 16px 24px 24px;
}

.three-dot .ant-dropdown-trigger {
  border: 0px;
  background-color: rgba(0, 0, 0, 0);
  box-shadow: 0 2px 0 rgb(0 0 0 / 0%);
}

.without-border-button {
  border: none;
  background: none;
  box-shadow: none;
}

.horizontal-three-dots svg {
  transform: translate(0px, -7px);
  -ms-transform: translate(0px, -7px);
  -webkit-transform: translate(0px, -7px);
  -o-transform: translate(0px, -7px);
  -moz-transform: translate(0px, -7px);
}

.three-dot:hover {
  border: 0px;
  background-color: rgba(0, 0, 0, 0) !important;
  box-shadow: 0 2px 0 rgb(0 0 0 / 0%);
}

.icon-color {
  fill: var(--icon-color);
}

.info-part {
  background-color: white;
  padding: 24px var(--gutter-desktop) 25px var(--gutter-desktop);
  border-radius: var(--radius-md);
  border: 1px solid var(--border-color);
}

.drawer-form-part {
  background-color: white;
  padding: 0 var(--gutter-desktop) 25px var(--gutter-desktop);
  border-radius: var(--radius-md);
}

.link {
  cursor: pointer;
  text-decoration: underline;
  color: var(--primary-hover);
}

.ant-drawer .ant-drawer-content {
  border-radius: var(--radius-md) 0 0 var(--radius-md);
}

.ant-drawer-rtl .ant-drawer-content {
  border-radius: 0 var(--radius-md) var(--radius-md) 0;
}

.ant-btn-primary {
  box-shadow: none !important;
}

.three-dot>.ant-btn:first-child {
  padding: 0;
}


:where(.css-dev-only-do-not-override-14wwjjs).ant-input-number-affix-wrapper>div.ant-input-number {
  width: 100%;
  border: none;
  outline: none;
  height: 40px !important;
}

:where(.css-14wwjjs).ant-input-number-affix-wrapper>div.ant-input-number {
  width: 100%;
  border: none;
  outline: none;
  height: 40px !important;
}

.print-area {
  visibility: hidden;
  pointer-events: none;
  position: fixed;
  inset: 0;
}

@media print {
  .print-area {
    visibility: visible;
    pointer-events: auto;
    position: static;
  }

  .clinical-sider,
  .no-print,
  .ant-dropdown,
  .ant-dropdown-menu,
  .ant-drawer,
  .ant-modal-root,
  .ant-message,
  .ant-notification,
  .ant-tooltip {
    display: none !important;
  }

  html,
  body,
  #root,
  .clinical-shell,
  .clinical-main,
  .clinical-main__scroll {
    height: auto !important;
    min-height: 0 !important;
    max-height: none !important;
    overflow: visible !important;
    background: #ffffff !important;
  }

  .clinical-shell {
    display: block !important;
    padding: 0 !important;
    gap: 0 !important;
  }

  .clinical-main {
    border: 0 !important;
    border-radius: 0 !important;
    box-shadow: none !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/style.css"],"names":[],"mappings":"AAAA,mCAAmC;;AAInC;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,6BAA6B;EAC7B,+BAA+B;EAC/B,gDAAgD;AAClD;;AAEA;EACE,0CAA0C;EAC1C,0CAA0C;AAC5C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,4CAA4C;EAC5C,0CAA0C;AAC5C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uCAAuC;EACvC,0DAA0D;EAC1D,2DAA2D;EAC3D,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,sBAAsB;EACtB,+BAA+B;EAC/B,sBAAsB;;EAEtB,2BAA2B;EAC3B,uBAAuB;EACvB,uBAAuB;EACvB,8BAA8B;EAC9B,4BAA4B;EAC5B,4BAA4B;EAC5B,yCAAyC;EACzC,uCAAuC;EACvC,6BAA6B;EAC7B,8BAA8B;EAC9B,wBAAwB;EACxB,wBAAwB;EACxB,yBAAyB;EACzB,kCAAkC;EAClC,yBAAyB;EACzB,mCAAmC;EACnC,2BAA2B;EAC3B,0BAA0B;EAC1B,oDAAoD;EACpD,gCAAgC;EAChC,yDAAyD;EACzD,qCAAqC;EACrC,iCAAiC;EACjC,qBAAqB;EACrB,qBAAqB;EACrB,8BAA8B;EAC9B,6BAA6B;EAC7B,yBAAyB;EACzB,oBAAoB;EACpB,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;EACrB,sCAAsC;AACxC;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,wBAAwB;EACxB,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;EACvB,wCAAwC;EACxC,4CAA4C;EAC5C,0BAA0B;EAC1B,0CAA0C;EAC1C,sCAAsC;EACtC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,uBAAuB;EACvB,2BAA2B;AAC7B;AACA;EACE,uBAAuB;EACvB,wCAAwC;EACxC,4CAA4C;EAC5C,0BAA0B;EAC1B,0CAA0C;EAC1C,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gDAAgD;EAChD,uCAAuC;AACzC;;AAEA;EACE,uBAAuB;EACvB,wCAAwC;EACxC,4CAA4C;EAC5C,0BAA0B;EAC1B,0CAA0C;EAC1C,sCAAsC;EACtC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;;EAEE,iDAAiD;AACnD;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,eAAe;EACf,+BAA+B;EAC/B,uCAAuC;EACvC,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;AACvC;;AAEA;;EAEE,uCAAuC;EACvC,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;;EAEE,4CAA4C;EAC5C,0CAA0C;EAC1C,wCAAwC;AAC1C;;AAEA;;EAEE,4CAA4C;EAC5C,kBAAkB;EAClB,sDAAsD;EACtD,yCAAyC;EACzC,wCAAwC;AAC1C;;AAEA;EACE,4CAA4C;EAC5C,0CAA0C;AAC5C;;AAEA;EACE,4CAA4C;EAC5C,mDAAmD;EACnD,sDAAsD;AACxD;;AAEA;EACE,kDAAkD;EAClD,oDAAoD;EACpD,uDAAuD;AACzD;;AAEA;;;;EAIE,6CAA6C;EAC7C,4EAA4E;AAC9E;;AAEA;;;;;EAKE,4DAA4D;AAC9D;;AAEA;;EAEE,oDAAoD;AACtD;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;AAChC;;AAEA;;EAEE,qDAAqD;AACvD;;AAEA;EACE,iCAAiC;EACjC,4CAA4C;EAC5C,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,sCAAsC;AACxC;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,sBAAsB;AACxB;;;AAGA;;EAEE,2CAA2C;EAC3C,qDAAqD;AACvD;;AAEA;;EAEE,2CAA2C;AAC7C;;AAEA;;EAEE,2CAA2C;EAC3C,sDAAsD;AACxD;;AAEA;;EAEE,2CAA2C;AAC7C;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;;;EAIE,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;EACrB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;EAChC,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;;AAEA;;;EAGE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;;;EAIE,YAAY;AACd;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kCAAkC;EAClC,mCAAmC;AACrC;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,mCAAmC;EACnC,uCAAuC;EACvC,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,6CAA6C;EAC7C,mCAAmC;AACrC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,8DAA8D;EAC9D,+BAA+B;EAC/B,qCAAqC;AACvC;;AAEA;EACE,uBAAuB;EACvB,2DAA2D;EAC3D,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,UAAU;AACZ;;;AAGA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,QAAQ;AACV;;AAEA;EACE;IACE,mBAAmB;IACnB,oBAAoB;IACpB,gBAAgB;EAClB;;EAEA;;;;;;;;;IASE,wBAAwB;EAC1B;;EAEA;;;;;;IAME,uBAAuB;IACvB,wBAAwB;IACxB,2BAA2B;IAC3B,4BAA4B;IAC5B,8BAA8B;EAChC;;EAEA;IACE,yBAAyB;IACzB,qBAAqB;IACrB,iBAAiB;EACnB;;EAEA;IACE,oBAAoB;IACpB,2BAA2B;IAC3B,2BAA2B;EAC7B;AACF","sourcesContent":["/* @import '~antd/dist/antd.css'; */\n\n@import url(\"https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=Public+Sans:wght@500;600&display=swap\");\n\nhtml {\n  direction: ltr;\n}\n\nhtml[dir='rtl'],\nhtml[dir='rtl'] body {\n  direction: rtl;\n}\n\nbody {\n  margin: 0;\n  font-family: var(--font-sans);\n  color: var(--header-text-color);\n  background-color: var(--backgorud-default-color);\n}\n\n.error-toastr {\n  background-color: var(--error-color-state);\n  border-radius: var(--radius-md) !important;\n}\n\n.ant-notification-notice-with-icon .ant-notification-notice-message {\n  color: white;\n}\n\n.success-toastr {\n  background-color: var(--success-color-state);\n  border-radius: var(--radius-md) !important;\n}\n\n.ant-notification-close-x .anticon svg {\n  display: none;\n}\n\n:root {\n  /* Clinical Precision System (Stitch) */\n  --font-sans: 'Inter', system-ui, -apple-system, sans-serif;\n  --font-label: 'Public Sans', 'Inter', system-ui, sans-serif;\n  --radius-md: 8px;\n  --radius-lg: 12px;\n  --control-height: 36px;\n  --sidebar-width: 256px;\n  --sidebar-collapsed-width: 72px;\n  --gutter-desktop: 24px;\n\n  --input-text-color: #0F172A;\n  --border-color: #CBD5E1;\n  --border-muted: #E2E8F0;\n  --success-color-state: #10B981;\n  --error-color-state: #DC2626;\n  --header-text-color: #0F172A;\n  --success-color-state-for-inputs: #059669;\n  --error-color-state-for-inputs: #B91C1C;\n  --drower-close-color: #DC2626;\n  --warning-color-state: #D97706;\n  --primary-color: #0EA5E9;\n  --primary-hover: #0284C7;\n  --primary-active: #1E3A8A;\n  --backgorud-default-color: #F1F5F9;\n  --surface-subtle: #F8FAFC;\n  --table-body-content-color: #475569;\n  --description-text: #64748B;\n  --tab-title-color: #64748B;\n  --profile-job-tag-background-color-hex: 183, 51, 232;\n  --profile-job-tag-color: #a80ced;\n  --profile-availability-background-color-hex: 16, 185, 129;\n  --profile-availability-color: #10B981;\n  --primary-color-hex: 14, 165, 233;\n  --menu-color: #0F172A;\n  --icon-color: #64748B;\n  --selected-menu-color: #E0F2FE;\n  --selected-menu-text: #0284C7;\n  --report-numbers: #1E3A8A;\n  --rx-top-offset: 0px;\n  --rx-right-offset: 0px;\n  --rx-bottom-offset: 0px;\n  --rx-left-offset: 0px;\n  --focus-ring: rgba(14, 165, 233, 0.20);\n}\n\n.Header-24-bold {\n  font-family: var(--font-sans);\n  font-size: 24px;\n  font-weight: 600;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 30px;\n  letter-spacing: -0.015em;\n  color: var(--header-text-color);\n}\n\n.Header-20-bold {\n  font-family: var(--font-sans);\n  font-size: 20px;\n  font-weight: 600;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 26px;\n  letter-spacing: -0.01em;\n  color: var(--header-text-color);\n}\n\n.Header-18-M {\n  font-family: var(--font-sans);\n  font-size: 16px;\n  font-weight: 600;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 22px;\n  letter-spacing: -0.005em;\n}\n\n.Header-16-M {\n  font-family: var(--font-sans);\n  font-size: 13px;\n  font-weight: 600;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 16px;\n  letter-spacing: 0;\n}\n\n.Header-R-16 {\n  font-family: var(--font-sans);\n  font-size: 15px;\n  font-weight: 400;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 22px;\n  letter-spacing: normal;\n}\n\n.Header-R-14 {\n  font-family: var(--font-label);\n  font-size: 13px;\n  font-weight: 500;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 16px;\n  letter-spacing: normal;\n}\n\n.body---14pt-R {\n  font-family: var(--font-sans);\n  font-size: 14px;\n  font-weight: 400;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 20px;\n  letter-spacing: normal;\n}\n\n.body-8pt {\n  font-family: var(--font-label);\n  font-size: 11px;\n  font-weight: 600;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 14px;\n  letter-spacing: 0.04em;\n}\n\n.title {\n  margin-bottom: 36px;\n}\n\n.hidden-divider {\n  min-height: 36px;\n}\n\n.table-body-content {\n  color: var(--table-body-content-color);\n}\n\n.description-text {\n  color: var(--description-text);\n}\n\n.description-text-heavy {\n  color: #525b66;\n}\n\n.report_number {\n  color: var(--report-numbers);\n}\n\n.normal-button {\n  width: 186px !important;\n  height: var(--control-height) !important;\n  min-height: var(--control-height) !important;\n  padding: 0 20px !important;\n  border-radius: var(--radius-md) !important;\n  background-color: var(--primary-color);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-color: rgba(0, 0, 0, 0);\n  color: white !important;\n  box-shadow: none !important;\n}\n.drawer-close-button {\n  width: 186px !important;\n  height: var(--control-height) !important;\n  min-height: var(--control-height) !important;\n  padding: 0 20px !important;\n  border-radius: var(--radius-md) !important;\n  background-color: white !important;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid var(--border-color) !important;\n  color: var(--primary-active) !important;\n}\n\n.widder-normal-button {\n  width: 220px !important;\n  height: var(--control-height) !important;\n  min-height: var(--control-height) !important;\n  padding: 0 20px !important;\n  border-radius: var(--radius-md) !important;\n  background-color: var(--primary-color);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-color: rgba(0, 0, 0, 0);\n  color: white !important;\n  box-shadow: none !important;\n}\n\n.normal-button:hover,\n.normal-button:focus {\n  background-color: var(--primary-hover) !important;\n}\n\n.normal-button:active {\n  background-color: var(--primary-active) !important;\n}\n\n.normal-secondary-button {\n  width: 188px;\n  height: var(--control-height);\n  padding: 0 20px;\n  border-radius: var(--radius-md);\n  background-color: var(--surface-subtle);\n  color: var(--primary-active);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid var(--border-color);\n}\n\n.normal-secondary-button:hover,\n.normal-secondary-button:focus {\n  background-color: var(--surface-subtle);\n  color: var(--primary-active);\n  border-color: #94A3B8;\n}\n\n.input-border,\n.ant-select-selector {\n  border-color: var(--border-color) !important;\n  border-radius: var(--radius-md) !important;\n  height: var(--control-height) !important;\n}\n\n.group-input-border,\n.ant-select-selector {\n  border-color: var(--border-color) !important;\n  border-radius: 0px;\n  border-start-start-radius: var(--radius-md) !important;\n  border-end-start-radius: var(--radius-md);\n  height: var(--control-height) !important;\n}\n\n.text-area-border {\n  border-color: var(--border-color) !important;\n  border-radius: var(--radius-md) !important;\n}\n\n.ant-input-wrapper.ant-input-group input {\n  border-color: var(--border-color) !important;\n  border-top-left-radius: var(--radius-md) !important;\n  border-bottom-left-radius: var(--radius-md) !important;\n}\n\n.ant-input-wrapper.ant-input-group .ant-select {\n  /* border-color: var(--border-color) !important; */\n  border-top-right-radius: var(--radius-md) !important;\n  border-bottom-right-radius: var(--radius-md) !important;\n}\n\n.ant-input:focus,\n.ant-input-focused,\n.ant-select-focused .ant-select-selector,\n.ant-picker-focused {\n  border-color: var(--primary-color) !important;\n  box-shadow: 0 0 0 2px var(--focus-ring, rgba(14, 165, 233, 0.20)) !important;\n}\n\n.ant-form-item-has-error input,\n.ant-form-item-has-error .ant-input-number,\n.ant-form-item-has-error :not(.ant-input-affix-wrapper-disabled):not(.ant-input-affix-wrapper-borderless).ant-input-affix-wrapper,\n.ant-form-item-has-error .ant-select:not(.ant-select-disabled):not(.ant-select-customize-input) .ant-select-selector,\n.ant-form-item-has-error .ant-picker {\n  border-color: var(--error-color-state-for-inputs) !important;\n}\n\n.ant-form-item-has-error #Vector-2,\n.ant-form-item-has-error #Vector-3 {\n  fill: var(--error-color-state-for-inputs) !important;\n}\n\n.ant-input-number {\n  display: flex !important;\n  align-items: center !important;\n}\n\n.ant-form-item-explain,\n.ant-form-item-has-error.ant-form-item-has-feedback .ant-form-item-children-icon {\n  color: var(--error-color-state-for-inputs) !important;\n}\n\n.ant-table-thead>tr>th {\n  background: var(--surface-subtle);\n  border-bottom: 1px solid var(--border-color);\n  font-family: var(--font-label);\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: var(--table-body-content-color);\n}\n\n.ant-table-tbody>tr>td {\n  border-bottom: 1px solid var(--border-muted);\n}\n\n.ant-table-tbody>tr:hover>td {\n  background: var(--backgorud-default-color) !important;\n}\n\ntd {\n  background-color: #fff;\n}\n\n\n.ant-layout.ant-layout-has-sider.ant-layout-rtl td:first-child,\n.ant-layout.ant-layout-has-sider.ant-layout-rtl th:first-child {\n  border-radius: 0px 10px 10px 0px !important;\n  border-left: 1px solid var(--backgorud-default-color);\n}\n\n.ant-layout.ant-layout-has-sider.ant-layout-rtl td:last-child,\n.ant-layout.ant-layout-has-sider.ant-layout-rtl th:last-child {\n  border-radius: 10px 0px 0px 10px !important;\n}\n\n.ant-layout.ant-layout-has-sider td:first-child,\n.ant-layout.ant-layout-has-sider th:first-child {\n  border-radius: 10px 0px 0px 10px !important;\n  border-right: 1px solid var(--backgorud-default-color);\n}\n\n.ant-layout.ant-layout-has-sider td:last-child,\n.ant-layout.ant-layout-has-sider th:last-child {\n  border-radius: 0px 10px 10px 0px !important;\n}\n\n.ant-table {\n  background: rgba(0, 0, 0, 0);\n}\n\n.ant-table table {\n  /* border-spacing: 0px 10px; */\n}\n\n.ant-table-thead>tr>th,\n.ant-table-tbody>tr>td,\n.ant-table tfoot>tr>th,\n.ant-table tfoot>tr>td {\n  padding: 8px 16px;\n}\n\n.action-button {\n  display: flex !important;\n  align-items: flex-end;\n  justify-content: flex-end;\n  font-size: 20px;\n}\n\n.page-header {\n  background-color: #ffffff;\n  border-bottom: 1px solid #E2E8F0;\n  padding: 20px 24px 16px;\n  margin: 0;\n  position: sticky;\n  top: 0;\n  z-index: 3;\n}\n\n.site-content-collapsed-layout .page-header,\n.ant-layout-rtl .page-header,\n.ant-layout-rtl .site-content-collapsed-layout .page-header {\n  left: auto !important;\n  right: auto !important;\n}\n\n.ant-layout {\n  background-color: transparent;\n}\n\n.page-content,\n.index-page-content,\n.new-pages-content,\n.new-pages-content-with-header {\n  margin: 24px;\n}\n\n.page-subcontent,\n.new-pages-sub-content {\n  margin: 16px 24px 24px;\n}\n\n.three-dot .ant-dropdown-trigger {\n  border: 0px;\n  background-color: rgba(0, 0, 0, 0);\n  box-shadow: 0 2px 0 rgb(0 0 0 / 0%);\n}\n\n.without-border-button {\n  border: none;\n  background: none;\n  box-shadow: none;\n}\n\n.horizontal-three-dots svg {\n  transform: translate(0px, -7px);\n  -ms-transform: translate(0px, -7px);\n  -webkit-transform: translate(0px, -7px);\n  -o-transform: translate(0px, -7px);\n  -moz-transform: translate(0px, -7px);\n}\n\n.three-dot:hover {\n  border: 0px;\n  background-color: rgba(0, 0, 0, 0) !important;\n  box-shadow: 0 2px 0 rgb(0 0 0 / 0%);\n}\n\n.icon-color {\n  fill: var(--icon-color);\n}\n\n.info-part {\n  background-color: white;\n  padding: 24px var(--gutter-desktop) 25px var(--gutter-desktop);\n  border-radius: var(--radius-md);\n  border: 1px solid var(--border-color);\n}\n\n.drawer-form-part {\n  background-color: white;\n  padding: 0 var(--gutter-desktop) 25px var(--gutter-desktop);\n  border-radius: var(--radius-md);\n}\n\n.link {\n  cursor: pointer;\n  text-decoration: underline;\n  color: var(--primary-hover);\n}\n\n.ant-drawer .ant-drawer-content {\n  border-radius: var(--radius-md) 0 0 var(--radius-md);\n}\n\n.ant-drawer-rtl .ant-drawer-content {\n  border-radius: 0 var(--radius-md) var(--radius-md) 0;\n}\n\n.ant-btn-primary {\n  box-shadow: none !important;\n}\n\n.three-dot>.ant-btn:first-child {\n  padding: 0;\n}\n\n\n:where(.css-dev-only-do-not-override-14wwjjs).ant-input-number-affix-wrapper>div.ant-input-number {\n  width: 100%;\n  border: none;\n  outline: none;\n  height: 40px !important;\n}\n\n:where(.css-14wwjjs).ant-input-number-affix-wrapper>div.ant-input-number {\n  width: 100%;\n  border: none;\n  outline: none;\n  height: 40px !important;\n}\n\n.print-area {\n  visibility: hidden;\n  pointer-events: none;\n  position: fixed;\n  inset: 0;\n}\n\n@media print {\n  .print-area {\n    visibility: visible;\n    pointer-events: auto;\n    position: static;\n  }\n\n  .clinical-sider,\n  .no-print,\n  .ant-dropdown,\n  .ant-dropdown-menu,\n  .ant-drawer,\n  .ant-modal-root,\n  .ant-message,\n  .ant-notification,\n  .ant-tooltip {\n    display: none !important;\n  }\n\n  html,\n  body,\n  #root,\n  .clinical-shell,\n  .clinical-main,\n  .clinical-main__scroll {\n    height: auto !important;\n    min-height: 0 !important;\n    max-height: none !important;\n    overflow: visible !important;\n    background: #ffffff !important;\n  }\n\n  .clinical-shell {\n    display: block !important;\n    padding: 0 !important;\n    gap: 0 !important;\n  }\n\n  .clinical-main {\n    border: 0 !important;\n    border-radius: 0 !important;\n    box-shadow: none !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
